var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "text-color-wrapper" }, [
    _c(
      "section",
      { staticClass: "color-section" },
      [
        _c(_setup.ColorOptionsClipboardButtons, {
          attrs: {
            title: "Fill",
            "can-copy": !_setup.disabled,
            "can-paste": _setup.canPasteFillColors,
          },
          on: {
            copy: _setup.onCopyFillColors,
            paste: _setup.onPasteFillColors,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "border-bottom" }),
        _vm._v(" "),
        _c(_setup.ElementLibrarySelector, {
          attrs: {
            disabled: _setup.disabled,
            "element-list": _setup.model.fontColorsMap,
            "library-id": _setup.model.colorLibraryId,
            "selected-group": _vm.selectedGroup,
            "library-type": _setup.COLOR_TYPE,
            "selected-position": _setup.model.fontColorOption,
            cmyk: _vm.cmykMode,
            "show-menu-types": _setup.showMenuTypes,
            "enable-palette": _setup.isPaletteEnabled,
            "mixed-library": _setup.model.isColorLibraryIdMixed,
            "mixed-element-list": _setup.model.isFontColorsMixed,
          },
          on: {
            "pick-library": _setup.pickColorLibrary,
            "remove-library": _setup.removeColorLibrary,
            "option-selected": _setup.onColorSelected,
            "remove-map-option": _setup.removeColorOptionFromMap,
            "load-option": _setup.onLoadOption,
            "options-reordered": _setup.onColorOptionsReordered,
            "preview-selection": _setup.previewColorOption,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "color-section" },
      [
        _c(_setup.ColorOptionsClipboardButtons, {
          attrs: {
            title: "Stroke",
            "can-copy": !_setup.disabled && _setup.isStrokeEnabled,
            "can-paste": _setup.canPasteStrokeColors,
          },
          on: {
            copy: _setup.onCopyStrokeColors,
            paste: _setup.onPasteStrokeColors,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "border-bottom" }),
        _vm._v(" "),
        !_setup.isStrokeEnabled
          ? _c(_setup.CButton, {
              attrs: {
                variant: "secondary",
                text: "Add Stroke",
                icon: ["far", "plus"],
                disabled: _setup.disabled,
              },
              on: { click: _setup.toggleStrokeSection },
            })
          : _c(
              _setup.ElementLibrarySelector,
              {
                attrs: {
                  disabled: _setup.disabled,
                  "element-list": _setup.model.outlineColorsMap,
                  "library-id": _setup.model.outlineColorLibraryId,
                  "library-type": _setup.COLOR_TYPE,
                  "selected-position": _setup.model.outlineColorOption,
                  cmyk: _vm.cmykMode,
                  "mixed-library": _setup.model.isOutlineColorLibraryIdMixed,
                  "mixed-element-list": _setup.model.isOutlineColorsMixed,
                },
                on: {
                  "pick-library": function ($event) {
                    return _setup.pickColorLibrary(true)
                  },
                  "remove-library": function ($event) {
                    return _setup.removeColorLibrary(
                      _setup.outlineKeyMap.strokeLibraryId
                    )
                  },
                  "option-selected": _setup.onOutlineColorSelected,
                  "remove-map-option": function ($event) {
                    return _setup.removeColorOptionFromMap(
                      $event,
                      _setup.outlineKeyMap.strokeColorsMap
                    )
                  },
                  "load-option": (option, value) =>
                    _setup.onLoadOption(option, value, true),
                  "options-reordered": function ($event) {
                    return _setup.onColorOptionsReordered(
                      $event,
                      _setup.outlineKeyMap.strokeColorsMap
                    )
                  },
                  "preview-selection": function ($event) {
                    return _setup.previewColorOption($event, true)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    _setup.isHeaderSlotActive
                      ? {
                          key: "actions",
                          fn: function () {
                            return [
                              _setup.isStrokeEnabled
                                ? _c(_setup.CButton, {
                                    staticClass: "remove-stroke-btn",
                                    attrs: {
                                      variant: "secondary",
                                      text: "Remove Stroke",
                                      icon: ["far", "trash"],
                                      disabled: _setup.disabled,
                                    },
                                    on: { click: _setup.toggleStrokeSection },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              },
              [
                _c(
                  "template",
                  { slot: _setup.currentSlot },
                  [
                    _c(_setup.CInput, {
                      attrs: {
                        label: "Width",
                        min: 0,
                        placeholder: _setup.outlineWidthPlaceholder,
                        type: "number",
                        disabled: _setup.disabled,
                      },
                      on: { input: _setup.updateOutlineWidth },
                      model: {
                        value: _setup.model.outlineWidth,
                        callback: function ($$v) {
                          _vm.$set(_setup.model, "outlineWidth", $$v)
                        },
                        expression: "model.outlineWidth",
                      },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
      ],
      1
    ),
    _vm._v(" "),
    _setup.type.text && !_setup.props.selectedGroup && !_setup.hasTextPathDraw
      ? _c("section", { staticClass: "color-section" }, [
          _c("h6", [_vm._v("Texture")]),
          _vm._v(" "),
          _c("div", { staticClass: "border-bottom" }),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-center" }, [
            _c(
              "div",
              { staticClass: "col-6 d-flex align-items-end pr-0" },
              [
                _c(_setup.CSelect, {
                  staticClass: "flex-fill",
                  attrs: {
                    label: "Texture",
                    placeholder: "Select a texture",
                    clearable: "",
                    searchable: "",
                    filterable: "",
                    value: _setup.model.texture,
                    disabled:
                      _setup.disabled ||
                      _vm.isTextureDisabled ||
                      _vm.shadowApplied,
                    options: _setup.userTextures,
                    "model-transform": _setup.valueReducer,
                  },
                  on: {
                    input: _setup.onTextureSelected,
                    "delete-option": function ($event) {
                      return _setup.deleteFontTexture($event.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.allowTextureUpload
                  ? _c(_setup.CFileInput, {
                      attrs: {
                        value: [],
                        accept: ".png,.jpg,.jpeg",
                        "display-preview": false,
                        disabled:
                          _setup.disabled ||
                          _vm.isTextureDisabled ||
                          _vm.shadowApplied,
                      },
                      on: { input: _setup.onTextureUpload },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "uploadTrigger",
                            fn: function ({
                              onFileUpload,
                              disabled: triggerDisabled,
                            }) {
                              return [
                                _c(_setup.CButton, {
                                  staticClass: "ml-2",
                                  attrs: {
                                    variant: "secondary",
                                    icon: ["far", "plus"],
                                    disabled: triggerDisabled,
                                  },
                                  on: { click: onFileUpload },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3619602670
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("label", [
                  _vm._v("Scale: " + _vm._s(_setup.model.textureScale) + "%"),
                ]),
                _vm._v(" "),
                _c(_setup.CSlider, {
                  attrs: {
                    formatter: "{value}%",
                    max: 500,
                    disabled:
                      _setup.disabled ||
                      _vm.isTextureDisabled ||
                      _vm.shadowApplied ||
                      !_setup.model.textures.length,
                  },
                  on: { input: _setup.changeTextureScale },
                  model: {
                    value: _setup.model.textureScale,
                    callback: function ($$v) {
                      _vm.$set(_setup.model, "textureScale", $$v)
                    },
                    expression: "model.textureScale",
                  },
                }),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }